import {
  withGoogleMap,
  GoogleMap,
  DirectionsRenderer,
} from 'react-google-maps';

import React, { Component } from 'react';

export default function Map({lat, lng, directions}) {
  const GoogleMapExample = withGoogleMap((props) => (
    <GoogleMap
      defaultCenter={{ lat: lat, lng: lng }}
      defaultZoom={15}
    >
      {directions && (
        <DirectionsRenderer directions={directions} />
      )}
    </GoogleMap>
    
  ));

  return (
    <GoogleMapExample
          containerElement={<div style={{ height: `var(--map-height)`, width: '100%' }} />}
          mapElement={<div style={{ height: `100%` }} />}
        />
  )
}